import { ParentComponent } from "./Components/ParentComponent/ParentComponent";

export const App = () => {
  return <ParentComponent />;
};
